import { PlatformSiteAri } from '@atlassian/ari';

import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { objectTypes, PAGE_SIZE } from './recentQueryConstants.ts';
import RecentContentMenuQuery, {
	type RecentContentMenuQuery$data,
	type RecentContentMenuQuery$variables,
} from './queries/__generated__/RecentContentMenuQuery.graphql.ts';

export function preloadRecentContentMenu(cloudId: any) {
	return queryAgg<RecentContentMenuQuery$data, RecentContentMenuQuery$variables>({
		query: RecentContentMenuQuery,
		variables: {
			cloudId: PlatformSiteAri.create({ siteId: cloudId }).toString(),
			after: '',
			first: PAGE_SIZE,
			eventTypes: [],
			objectTypes: objectTypes(),
		},
		fetchPolicy: 'network-only',
	});
}
